import { EFinancingOfferRoute, EFinancingProductId } from '@/types'

export const FINANCING_PRODUCTS_MFO: EFinancingProductId[] = [EFinancingProductId.AGROINTEGRATOR, EFinancingProductId.MONEY_KAPITAL]

export const FINANCING_PRODUCT_BY_ROUTE: Partial<Record<EFinancingOfferRoute, EFinancingProductId>> = {
  [EFinancingOfferRoute.MFOPage]: EFinancingProductId.EXPRESS_MFO,
  [EFinancingOfferRoute.FinancingAgentPage]: EFinancingProductId.AGENT,
  [EFinancingOfferRoute.oborotSber]: EFinancingProductId.REVOLVING_LOAN_SBER,
  [EFinancingOfferRoute.centerInvestLoan]: EFinancingProductId.CENTER_INVEST_LOAN,
  [EFinancingOfferRoute.investSber]: EFinancingProductId.SBER_INVESTMENT_LOAN,
  [EFinancingOfferRoute.advancePaymentOnFutureHarvest]: EFinancingProductId.ADVANCE_FUNDING,
  [EFinancingOfferRoute.sberLeasing]: EFinancingProductId.SBER_LEASING,
  [EFinancingOfferRoute.interleasing]: EFinancingProductId.LEASING_INTERLEASING,
  [EFinancingOfferRoute.agriculturalMachinesAndEquipmentLeasing]: EFinancingProductId.LEASING_RAL,
  [EFinancingOfferRoute.fleetFinanceLeasing]: EFinancingProductId.LEASING_FLEET_FINANCE,
}
